import React from 'react';

export const CheckoutConfirmation = () => <>
    <div className="checkout-confirmation wrapped-profile-container">
        Payment successful!
    </div>
</>